import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { BREAKPOINTS, MAX_CONTENT_WIDTH } from '@/styles/themes/default';

import { ParagraphContainer, Heading } from './Common';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 512px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    flex-direction: row;
    max-width: ${MAX_CONTENT_WIDTH}px;
  }
`;

const MessageContainer = styled(ParagraphContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 40px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-bottom: 0;
    max-width: 390px;
  }
`;

const ImageContainer = styled.picture`
  display: flex;
  max-width: 512px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 740px;
  }

  img {
    width: 100%;
    max-height: 720px;
    margin-left: auto;
  }
`;

const Title = styled(Heading)`
  margin-bottom: 32px;
`;

export const GlobalAudience = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <MessageContainer>
        <Title>{t('landing.globalAudience.title')}</Title>
        <p>{t('landing.globalAudience.description')}</p>
        <p>{t('landing.globalAudience.informedDecision')}</p>
      </MessageContainer>
      <ImageContainer>
        <img src="/images/landing/globe.png" alt="global audience" />
      </ImageContainer>
    </Wrapper>
  );
};
